(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-034"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBar034 extends HTMLElement {
    connectedCallback() {
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.pauseBtn = this.querySelector('[ref="pause"]');
      this.userPaused = false;
      this.hovering = false;
      this.focusing = false;

      if (this.dataset.mode === 'marquee') this.initMarquee();
      else this.initRotate();

      if (this.pauseBtn) {
        if (this.reduced) this.pauseBtn.hidden = true;
        this.pauseBtn.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.sync();
        });
      }

      this.addEventListener('mouseenter', () => {
        if (this.dataset.pauseHover !== 'true') return;
        this.hovering = true;
        this.sync();
      });
      this.addEventListener('mouseleave', () => {
        this.hovering = false;
        this.sync();
      });
      this.addEventListener('focusin', () => {
        this.focusing = true;
        this.sync();
      });
      this.addEventListener('focusout', (e) => {
        if (this.contains(e.relatedTarget)) return;
        this.focusing = false;
        this.sync();
      });
      this.onVisibility = () => this.sync();
      document.addEventListener('visibilitychange', this.onVisibility);

      // Editor de tema: ao selecionar um bloco, mostra a mensagem correspondente.
      this.addEventListener('shopify:block:select', (e) => {
        const slide = e.target.closest('.ab034__slide');
        if (slide) {
          this.editorHold = true;
          this.go(parseInt(slide.dataset.index, 10) || 0);
          this.sync();
        }
      });
      this.addEventListener('shopify:block:deselect', () => {
        this.editorHold = false;
        this.sync();
      });

      this.sync();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.ro) this.ro.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
    }

    get running() {
      return !this.reduced && !this.userPaused && !this.hovering && !this.focusing && !this.editorHold && !document.hidden;
    }

    sync() {
      this.classList.toggle('is-paused', this.userPaused);
      if (this.pauseBtn) {
        const label = this.userPaused ? this.dataset.labelPlay : this.dataset.labelPause;
        if (label) this.pauseBtn.setAttribute('aria-label', label);
      }
      if (this.slidesEl) this.slidesEl.setAttribute('aria-live', this.running && this.autoplay ? 'off' : 'polite');
      if (this.dataset.mode === 'marquee') {
        this.classList.toggle('is-paused', this.userPaused || this.editorHold);
        return;
      }
      this.schedule();
    }

    /* ---------- ROTATE ---------- */
    initRotate() {
      this.slidesEl = this.querySelector('[ref="slides"]');
      this.slides = Array.from(this.querySelectorAll('.ab034__slide'));
      this.index = 0;
      this.autoplay = this.dataset.autoplay === 'true' && this.slides.length > 1;
      this.interval = Math.max(2, parseFloat(this.dataset.interval) || 5) * 1000;
      if (this.slides.length < 2) return;

      const prev = this.querySelector('[ref="prev"]');
      const next = this.querySelector('[ref="next"]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1, -1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1, 1));

      // Swipe (touch/pen)
      let x0 = null;
      this.slidesEl.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse') x0 = e.clientX;
      }, { passive: true });
      this.slidesEl.addEventListener('pointerup', (e) => {
        if (x0 == null) return;
        const dx = e.clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
      }, { passive: true });
      this.slidesEl.addEventListener('pointercancel', () => (x0 = null), { passive: true });
    }

    go(i, dir = 1) {
      if (!this.slides || this.slides.length < 2) return;
      const n = this.slides.length;
      const nextIndex = ((i % n) + n) % n;
      if (nextIndex === this.index) return;
      this.style.setProperty('--ab034-dir', dir < 0 ? -1 : 1);
      const cur = this.slides[this.index];
      const nxt = this.slides[nextIndex];
      cur.classList.remove('is-active');
      cur.classList.add('is-leaving');
      cur.setAttribute('aria-hidden', 'true');
      cur.inert = true;
      setTimeout(() => cur.classList.remove('is-leaving'), 500);
      nxt.classList.remove('is-leaving');
      nxt.classList.add('is-active');
      nxt.removeAttribute('aria-hidden');
      nxt.inert = false;
      this.index = nextIndex;
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      if (!this.autoplay || !this.running) return;
      this.timer = setTimeout(() => this.go(this.index + 1, 1), this.interval);
    }

    /* ---------- MARQUEE ---------- */
    initMarquee() {
      this.track = this.querySelector('[ref="track"]');
      const base = this.querySelector('.ab034__group');
      if (!this.track || !base) return;
      this.groupHTML = base.outerHTML;
      this.build();
      if ('ResizeObserver' in window) {
        let raf;
        let lastW = this.offsetWidth;
        this.ro = new ResizeObserver(() => {
          if (this.offsetWidth === lastW) return;
          lastW = this.offsetWidth;
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => this.build());
        });
        this.ro.observe(this);
      }
    }

    build() {
      const viewport = this.querySelector('.ab034__viewport');
      const containerW = viewport ? viewport.offsetWidth : this.offsetWidth;
      if (!containerW) return;
      this.track.innerHTML = this.groupHTML;
      const group = this.track.firstElementChild;
      const groupW = group.offsetWidth;
      if (!groupW || this.reduced) {
        this.classList.remove('is-marquee');
        return;
      }
      const copies = Math.max(1, Math.ceil(containerW / groupW));
      const half = document.createElement('div');
      half.className = 'ab034__half';
      for (let i = 0; i < copies; i++) {
        const clone = group.cloneNode(true);
        if (i > 0) this.hideClone(clone);
        half.appendChild(clone);
      }
      const half2 = half.cloneNode(true);
      this.hideClone(half2);
      this.track.innerHTML = '';
      this.track.appendChild(half);
      this.track.appendChild(half2);
      const speed = parseFloat(this.dataset.speed) || 40;
      this.track.style.setProperty('--ab034-duration', half.offsetWidth / speed + 's');
      this.classList.add('is-marquee');
    }

    hideClone(el) {
      el.setAttribute('aria-hidden', 'true');
      el.inert = true;
      el.querySelectorAll('[data-shopify-editor-block]').forEach((n) => n.removeAttribute('data-shopify-editor-block'));
    }
  }

  if (!customElements.get('announcement-bar-034')) {
    customElements.define('announcement-bar-034', AnnouncementBar034);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["benefits-bar-034"] && !Shopify.designMode) return;
  try {
    
  class BenefitsCarousel034 extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[ref="track"]');
      if (!this.track) return;

      this.items = Array.from(this.track.children);
      this.dotsEl = this.querySelector('[ref="dots"]');
      this.prevBtn = this.querySelector('[ref="prev"]');
      this.nextBtn = this.querySelector('[ref="next"]');

      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.wantsAutoplay = this.dataset.autoplay === 'true';
      this.showDots = this.dataset.showDots === 'true';
      this.interval = parseInt(this.dataset.interval, 10) || 3500;
      this.index = 0;
      this.timer = null;

      this.onScroll = this.onScroll.bind(this);
      this.next = this.next.bind(this);

      if (this.items.length <= 1) {
        this.setControls(false);
        return;
      }

      this.bindArrows();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.bindInteractionPauses();

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => this.refresh());
        this.ro.observe(this.track);
      }
      this.onResize = () => this.refresh();
      window.addEventListener('resize', this.onResize, { passive: true });

      requestAnimationFrame(() => this.refresh());
    }

    disconnectedCallback() {
      this.stop();
      window.cancelAnimationFrame(this.raf);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      if (this.ro) this.ro.disconnect();
      if (this.onResize) window.removeEventListener('resize', this.onResize);
      if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.onMotionChange && this.reduceMotion.removeEventListener) {
        this.reduceMotion.removeEventListener('change', this.onMotionChange);
      }
    }

    get isScrollable() {
      return this.track.scrollWidth > this.track.clientWidth + 2;
    }

    refresh() {
      const active = this.isScrollable;
      this.setControls(active);
      if (active) {
        this.buildDots();
        this.updateActive();
        this.maybeAutoplay();
      } else {
        this.stop();
      }
    }

    setControls(active) {
      if (this.prevBtn) this.prevBtn.hidden = !active;
      if (this.nextBtn) this.nextBtn.hidden = !active;
      if (this.dotsEl && (!active || !this.showDots)) this.dotsEl.innerHTML = '';
    }

    bindArrows() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.prev();
          this.restart();
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          if (this.isAtEnd()) this.goTo(0);
          else this.goTo(this.index + 1);
          this.restart();
        });
      }
    }

    bindInteractionPauses() {
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.maybeAutoplay());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.maybeAutoplay());
      this.track.addEventListener('pointerdown', () => this.stop());
      this.track.addEventListener('touchstart', () => this.stop(), { passive: true });
      this.track.addEventListener('touchend', () => this.restart(), { passive: true });
      this.onVisibility = () => {
        if (document.hidden) this.stop();
        else this.maybeAutoplay();
      };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.onMotionChange = () => this.refresh();
      if (this.reduceMotion.addEventListener) {
        this.reduceMotion.addEventListener('change', this.onMotionChange);
      }
    }

    // Quantas "telas" de rolagem existem. Uma bolinha por ITEM não fazia sentido
    // quando 4+ itens aparecem ao mesmo tempo (6 bolinhas para 6 itens, mas só
    // ~1,5 posições reais de rolagem). Agora cada bolinha é uma página de fato.
    pageCount() {
      if (!this.track || !this.track.clientWidth) return 1;
      return Math.max(1, Math.ceil(this.track.scrollWidth / this.track.clientWidth - 0.05));
    }

    buildDots() {
      if (!this.dotsEl || !this.showDots) return;
      const total = this.pageCount();

      // Nada para rolar (todos os itens cabem) => sem bolinhas.
      if (total <= 1) {
        this.dotsEl.innerHTML = '';
        this.dots = [];
        return;
      }
      if (this.dots && this.dots.length === total) return;

      this.dotsEl.innerHTML = '';
      this.dots = Array.from({ length: total }, (_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'benefits-034__dot';
        dot.setAttribute('role', 'tab');
        const tpl = this.dotsEl.dataset.dotLabel || '[n] / [total]';
        dot.setAttribute('aria-label', tpl.replace('[n]', i + 1).replace('[total]', total));
        dot.addEventListener('click', () => {
          this.track.scrollTo({
            left: i * this.track.clientWidth,
            behavior: this.reduceMotion.matches ? 'auto' : 'smooth',
          });
          this.restart();
        });
        this.dotsEl.appendChild(dot);
        return dot;
      });
    }

    isAtEnd() {
      return this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
    }

    goTo(i) {
      const clamped = Math.max(0, Math.min(i, this.items.length - 1));
      this.index = clamped;
      const left = this.items[clamped].offsetLeft;
      const behavior = this.reduceMotion.matches ? 'auto' : 'smooth';
      this.track.scrollTo({ left: left, behavior: behavior });
    }

    prev() {
      if (this.track.scrollLeft <= 2) {
        this.index = this.items.length - 1;
        const behavior = this.reduceMotion.matches ? 'auto' : 'smooth';
        this.track.scrollTo({ left: this.track.scrollWidth, behavior: behavior });
      } else {
        this.goTo(this.index - 1);
      }
    }

    next() {
      if (this.isAtEnd()) this.goTo(0);
      else this.goTo(this.index + 1);
    }

    onScroll() {
      window.cancelAnimationFrame(this.raf);
      this.raf = window.requestAnimationFrame(() => this.updateActive());
    }

    updateActive() {
      const sl = this.track.scrollLeft;
      let closest = 0;
      let min = Infinity;
      this.items.forEach((item, i) => {
        const dist = Math.abs(item.offsetLeft - sl);
        if (dist < min) {
          min = dist;
          closest = i;
        }
      });
      this.index = closest;
      if (this.dots && this.dots.length) {
        // A bolinha ativa é a PÁGINA visível, não o item mais próximo.
        const w = this.track.clientWidth || 1;
        const pagina = Math.min(this.dots.length - 1, Math.round(sl / w));
        this.dots.forEach((dot, i) => {
          dot.setAttribute('aria-selected', i === pagina ? 'true' : 'false');
        });
      }
    }

    maybeAutoplay() {
      if (!this.wantsAutoplay || this.reduceMotion.matches || document.hidden) return;
      if (!this.isScrollable) return;
      this.start();
    }

    start() {
      this.stop();
      this.timer = window.setInterval(this.next, this.interval);
    }

    stop() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    restart() {
      this.stop();
      this.maybeAutoplay();
    }
  }

  if (!customElements.get('benefits-carousel-034')) {
    customElements.define('benefits-carousel-034', BenefitsCarousel034);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["coupon-bar-034"] && !Shopify.designMode) return;
  try {
    
  class CouponBar034 extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.cpn034__btn');
      this.label = this.querySelector('.cpn034__btn-label');
      this.status = this.querySelector('.cpn034__status');
      if (!this.button) return;
      this.defaultLabel = this.dataset.label || '';
      this.copiedLabel = this.dataset.copied || '';
      this.onClick = () => this.copy();
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onClick);
      clearTimeout(this.resetTimer);
    }

    async copy() {
      const code = this.dataset.code || '';
      let ok = false;
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(code);
          ok = true;
        } else {
          ok = this.fallbackCopy(code);
        }
      } catch (e) {
        ok = this.fallbackCopy(code);
      }
      if (ok) this.showFeedback();
    }

    fallbackCopy(text) {
      const ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'absolute';
      ta.style.left = '-9999px';
      document.body.appendChild(ta);
      ta.select();
      let ok = false;
      try {
        ok = document.execCommand('copy');
      } catch (e) {
        ok = false;
      }
      document.body.removeChild(ta);
      return ok;
    }

    showFeedback() {
      if (this.label) this.label.textContent = this.copiedLabel;
      if (this.status) this.status.textContent = this.copiedLabel;
      this.button.classList.add('is-copied');
      clearTimeout(this.resetTimer);
      this.resetTimer = setTimeout(() => {
        if (this.label) this.label.textContent = this.defaultLabel;
        if (this.status) this.status.textContent = '';
        this.button.classList.remove('is-copied');
      }, 2000);
    }
  }

  if (!customElements.get('coupon-bar-034')) {
    customElements.define('coupon-bar-034', CouponBar034);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-034"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('footer-accordion-034')) {
    class FooterAccordion034 extends HTMLElement {
      connectedCallback() {
        this.mq = window.matchMedia('(min-width: 750px)');
        this.sync = this.sync.bind(this);
        this.onClick = this.onClick.bind(this);
        this.mq.addEventListener('change', this.sync);
        this.addEventListener('click', this.onClick);
        this.sync();
      }

      disconnectedCallback() {
        if (this.mq) this.mq.removeEventListener('change', this.sync);
        this.removeEventListener('click', this.onClick);
      }

      get items() {
        return this.querySelectorAll('details.footer034__col');
      }

      sync() {
        const desktop = this.mq.matches;
        this.items.forEach((details) => {
          const summary = details.querySelector('summary');
          if (desktop) {
            details.open = true;
            if (summary) {
              summary.setAttribute('tabindex', '-1');
              summary.setAttribute('aria-disabled', 'true');
            }
          } else {
            details.open = details.dataset.mobileOpen === 'true';
            if (summary) {
              summary.removeAttribute('tabindex');
              summary.removeAttribute('aria-disabled');
            }
          }
        });
      }

      onClick(event) {
        if (!this.mq.matches) return;
        const summary = event.target.closest('summary');
        if (summary && this.contains(summary)) event.preventDefault();
      }
    }
    customElements.define('footer-accordion-034', FooterAccordion034);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["google-reviews-034"] && !Shopify.designMode) return;
  try {
    
  class GReviews034Carousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.arrows = Array.from(this.querySelectorAll('.greviews-034__arrow'));
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.onArrow = (e) => {
        const dir = parseInt(e.currentTarget.dataset.dir, 10);
        const card = this.track.querySelector('.greviews-034__card');
        const step = card ? card.offsetWidth + parseFloat(getComputedStyle(this.track).columnGap || 0) : this.track.clientWidth;
        this.track.scrollBy({ left: dir * step, behavior: this.reduce ? 'auto' : 'smooth' });
      };
      this.onScroll = () => this.update();
      this.onMore = (e) => {
        const btn = e.target.closest('.greviews-034__more');
        if (!btn) return;
        const text = btn.previousElementSibling;
        const open = btn.getAttribute('aria-expanded') !== 'true';
        text.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? this.dataset.less : this.dataset.more;
      };
      this.arrows.forEach((a) => a.addEventListener('click', this.onArrow));
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.addEventListener('click', this.onMore);
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(() => { this.measure(); this.update(); });
        this.ro.observe(this.track);
      }
      requestAnimationFrame(() => { this.measure(); this.update(); });
    }

    disconnectedCallback() {
      this.arrows?.forEach((a) => a.removeEventListener('click', this.onArrow));
      this.track?.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('click', this.onMore);
      this.ro?.disconnect();
    }

    // "Leia mais" só aparece quando o texto realmente passa do limite de linhas.
    measure() {
      this.querySelectorAll('.greviews-034__text').forEach((text) => {
        const btn = text.nextElementSibling;
        if (!btn || text.classList.contains('is-open')) return;
        btn.hidden = text.scrollHeight <= text.clientHeight + 1;
      });
    }

    update() {
      const overflow = this.track.scrollWidth > this.track.clientWidth + 2;
      this.classList.toggle('is-centered', !overflow);
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      this.arrows.forEach((a) => {
        a.hidden = !overflow;
        const dir = parseInt(a.dataset.dir, 10);
        a.disabled = dir < 0 ? this.track.scrollLeft <= 2 : this.track.scrollLeft >= max;
      });
    }
  }

  if (!customElements.get('greviews-034-carousel')) {
    customElements.define('greviews-034-carousel', GReviews034Carousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-034"] && !Shopify.designMode) return;
  try {
    
  class Header034 extends HTMLElement {
    connectedCallback() {
      this.burger = this.querySelector('[ref="burger"]');
      this.drawer = this.querySelector('[ref="drawer"]');
      this.closeBtn = this.querySelector('[ref="close"]');
      this.bar = this.querySelector('[ref="bar"]');
      this.catsScroller = this.querySelector('[ref="catsScroller"]');

      this.setupSticky();
      this.setupCatsFade();
      this.setupDrawer();
      this.setupCartDrawer();
      this.setupCounters();
    }

    /* ---------- Sticky + recolher categorias (IO + 1 listener passivo com rAF) ---------- */
    setupSticky() {
      if (this.dataset.sticky !== 'true') return;
      const wrapper = this.closest('.shopify-section') || this;

      // Sentinela FORA do wrapper sticky: quando sai da viewport, o header está grudado.
      let sentinel = wrapper.previousElementSibling;
      if (!sentinel || !sentinel.classList.contains('hd034-sentinel')) {
        sentinel = document.createElement('div');
        sentinel.className = 'hd034-sentinel';
        sentinel.setAttribute('aria-hidden', 'true');
        wrapper.before(sentinel);
      }
      this.sentinel = sentinel;

      // Altura útil do header grudado (para outros elementos sticky da página).
      if (this.bar && 'ResizeObserver' in window) {
        this.barObserver = new ResizeObserver(() => {
          document.body.style.setProperty('--header-height', this.bar.offsetHeight + 'px');
        });
        this.barObserver.observe(this.bar);
      }

      if (!('IntersectionObserver' in window)) return;
      this.stuck = false;
      this.stickyObserver = new IntersectionObserver((entries) => {
        this.stuck = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        this.classList.toggle('is-stuck', this.stuck);
        this.updateCats(0);
      });
      this.stickyObserver.observe(sentinel);

      const mode = this.dataset.catsScroll;
      if (mode === 'hide_show_up') {
        this.lastY = window.scrollY;
        this.onScroll = () => {
          if (this.ticking) return;
          this.ticking = true;
          requestAnimationFrame(() => {
            const y = window.scrollY;
            const dy = y - this.lastY;
            if (Math.abs(dy) > 8) {
              this.updateCats(dy);
              this.lastY = y;
            }
            this.ticking = false;
          });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }
    }

    updateCats(dy) {
      const mode = this.dataset.catsScroll;
      if (mode === 'keep') return;
      if (!this.stuck) {
        this.classList.remove('cats-hidden');
      } else if (mode === 'hide' || dy >= 0) {
        // dy === 0: acabou de grudar (ou carregou já rolado) → recolhe
        this.classList.add('cats-hidden');
      } else {
        this.classList.remove('cats-hidden');
      }
    }

    /* ---------- Fade de borda na strip rolável ---------- */
    setupCatsFade() {
      const el = this.catsScroller;
      if (!el) return;
      const update = () => {
        const max = el.scrollWidth - el.clientWidth;
        el.toggleAttribute('data-fade-start', el.scrollLeft > 2);
        el.toggleAttribute('data-fade-end', max > 2 && el.scrollLeft < max - 2);
      };
      this.updateFade = update;
      el.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
      if ('ResizeObserver' in window) {
        this.fadeObserver = new ResizeObserver(update);
        this.fadeObserver.observe(el);
      }
      update();
      // Categoria ativa visível na strip mobile
      const current = el.querySelector('[aria-current="page"]');
      if (current && el.scrollWidth > el.clientWidth) {
        el.scrollLeft = Math.max(0, current.offsetLeft - 24);
      }
    }

    /* ---------- Drawer (dialog nativo: top-layer, Esc, focus-trap) ---------- */
    setupDrawer() {
      if (!this.drawer || !this.burger) return;
      this.openDrawer = this.openDrawer.bind(this);
      this.closeDrawer = this.closeDrawer.bind(this);
      this.burger.addEventListener('click', this.openDrawer);
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.closeDrawer);
      this.drawer.addEventListener('click', (e) => {
        if (e.target === this.drawer) this.closeDrawer();
      });
      this.drawer.addEventListener('close', () => this.onDrawerClosed());
    }

    setupCartDrawer() {
      this.querySelectorAll('[data-open-cart-drawer]').forEach((btn) => {
        btn.addEventListener('click', () => {
          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          } else {
            window.location.href = btn.getAttribute('data-cart-url') || '/cart';
          }
        });
      });
    }

    openDrawer() {
      if (!this.drawer || typeof this.drawer.showModal !== 'function') return;
      this.lastFocused = document.activeElement;
      this.lockScroll();
      this.drawer.showModal();
      this.burger.setAttribute('aria-expanded', 'true');
    }

    closeDrawer() {
      if (this.drawer && this.drawer.open) this.drawer.close();
    }

    onDrawerClosed() {
      this.unlockScroll();
      this.burger.setAttribute('aria-expanded', 'false');
      if (this.lastFocused && typeof this.lastFocused.focus === 'function') this.lastFocused.focus();
    }

    lockScroll() {
      const root = document.documentElement;
      const sbw = window.innerWidth - root.clientWidth;
      this.prevPaddingRight = root.style.paddingRight;
      this.prevOverflow = root.style.overflow;
      if (sbw > 0) root.style.paddingRight = sbw + 'px';
      root.style.overflow = 'hidden';
    }

    unlockScroll() {
      const root = document.documentElement;
      root.style.overflow = this.prevOverflow || '';
      root.style.paddingRight = this.prevPaddingRight || '';
    }

    /* ---------- Contadores (carrinho + favoritos) ---------- */
    setupCounters() {
      this.cartCounters = Array.from(this.querySelectorAll('[data-cart-count]'));
      this.wishlistCounters = Array.from(this.querySelectorAll('[data-wishlist-count]'));

      this.onCartUpdate = (e) => {
        const d = e.detail || {};
        const count = d.data && d.data.itemCount != null ? d.data.itemCount : d.itemCount != null ? d.itemCount : null;
        if (count == null) return;
        this.renderCounters(this.cartCounters, count);
      };
      this.onWishlistChange = (e) => {
        const count = e.detail && e.detail.count != null ? e.detail.count : 0;
        this.renderCounters(this.wishlistCounters, count);
      };
      document.addEventListener('cart:update', this.onCartUpdate);
      document.addEventListener('wishlist:change', this.onWishlistChange);
    }

    renderCounters(nodes, count) {
      const n = parseInt(count, 10) || 0;
      nodes.forEach((el) => {
        el.textContent = n > 99 ? '99+' : String(n);
        el.hidden = n === 0;
      });
    }

    disconnectedCallback() {
      if (this.stickyObserver) this.stickyObserver.disconnect();
      if (this.barObserver) this.barObserver.disconnect();
      if (this.fadeObserver) this.fadeObserver.disconnect();
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      document.removeEventListener('cart:update', this.onCartUpdate);
      document.removeEventListener('wishlist:change', this.onWishlistChange);
    }
  }

  if (!customElements.get('header-034')) {
    customElements.define('header-034', Header034);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-carousel-034"] && !Shopify.designMode) return;
  try {
    
  class HeroCarousel034 extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.hc034__viewport');
      this.slides = Array.from(this.querySelectorAll('.hc034__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      this.playpause = this.querySelector('[data-playpause]');
      if (this.slides.length === 0) return;

      this.current = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.mqDesktop = window.matchMedia('(min-width: 750px)');
      this.interval = parseInt(this.dataset.interval, 10) || 5000;
      this.autoplayWanted = this.dataset.autoplay === 'true' && !this.reduced && this.slides.length > 1;
      this.playing = this.autoplayWanted;

      this.querySelectorAll('.hc034__video').forEach((v) => {
        v.muted = true;
        v.playsInline = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
      });

      this.onPrev = () => this.go(this.current - 1, true);
      this.onNext = () => this.go(this.current + 1, true);
      this.onToggle = () => this.toggle();
      this.onEnter = () => this.pauseTimer();
      this.onLeave = () => { if (this.playing) this.startTimer(); };
      this.onKey = (e) => {
        if (e.key === 'ArrowLeft') this.go(this.current - 1, true);
        else if (e.key === 'ArrowRight') this.go(this.current + 1, true);
      };
      this.onVisibility = () => {
        if (document.hidden) { this.pauseTimer(); this.syncMedia(); }
        else { this.syncMedia(); if (this.playing) this.startTimer(); }
      };
      this.onMq = () => this.syncMedia();

      // Swipe (touch/caneta): gesto horizontal troca de slide; vertical rola a página.
      this.onTouchStart = (e) => {
        const t = e.touches ? e.touches[0] : e;
        this.sx = t.clientX; this.sy = t.clientY; this.swiped = false;
      };
      this.onTouchEnd = (e) => {
        if (this.sx == null) return;
        const t = e.changedTouches ? e.changedTouches[0] : e;
        const dx = t.clientX - this.sx;
        const dy = t.clientY - this.sy;
        this.sx = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          this.swiped = true;
          this.go(this.current + (dx < 0 ? 1 : -1), true);
        }
      };
      // Evita abrir o link do slide ao final de um swipe.
      this.onClickCapture = (e) => {
        if (this.swiped) { e.preventDefault(); e.stopPropagation(); this.swiped = false; }
      };

      this.querySelector('[data-prev]')?.addEventListener('click', this.onPrev);
      this.querySelector('[data-next]')?.addEventListener('click', this.onNext);
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.dot, 10), true));
      });
      if (this.playpause) this.playpause.addEventListener('click', this.onToggle);
      this.addEventListener('mouseenter', this.onEnter);
      this.addEventListener('mouseleave', this.onLeave);
      this.addEventListener('keydown', this.onKey);
      document.addEventListener('visibilitychange', this.onVisibility);
      if (this.mqDesktop.addEventListener) this.mqDesktop.addEventListener('change', this.onMq);
      if (this.viewport && this.slides.length > 1) {
        this.viewport.addEventListener('touchstart', this.onTouchStart, { passive: true });
        this.viewport.addEventListener('touchend', this.onTouchEnd, { passive: true });
        this.viewport.addEventListener('click', this.onClickCapture, true);
      }

      this.setActive(0);
      if (this.playing) this.startTimer();
    }

    disconnectedCallback() {
      this.pauseTimer();
      document.removeEventListener('visibilitychange', this.onVisibility);
      if (this.mqDesktop && this.mqDesktop.removeEventListener) this.mqDesktop.removeEventListener('change', this.onMq);
      if (this.viewport) {
        this.viewport.removeEventListener('touchstart', this.onTouchStart);
        this.viewport.removeEventListener('touchend', this.onTouchEnd);
        this.viewport.removeEventListener('click', this.onClickCapture, true);
      }
    }

    // Toca só o vídeo do slide ativo e só a versão visível (mobile ou desktop).
    syncMedia() {
      const desktop = this.mqDesktop.matches;
      this.slides.forEach((slide, i) => {
        const active = i === this.current && !document.hidden;
        slide.querySelectorAll('.hc034__video').forEach((video) => {
          const isMobileVid = video.classList.contains('hc034__video--mobile');
          const hasMobile = slide.classList.contains('has-mobile-video');
          const visible = !hasMobile || (isMobileVid ? !desktop : desktop);
          if (active && visible && !this.reduced) {
            if (video.preload === 'none') video.preload = 'auto';
            const p = video.play();
            if (p && p.catch) p.catch(() => {});
          } else if (!video.paused) {
            video.pause();
          }
        });
        const iframe = slide.querySelector('.hc034__iframe');
        if (iframe && i === this.current && !iframe.getAttribute('src') && iframe.dataset.src) {
          iframe.setAttribute('src', iframe.dataset.src);
        }
      });
    }

    setActive(index) {
      this.slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-hidden', !active);
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      this.dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.current = index;
      this.syncMedia();
    }

    go(index, userAction) {
      const n = this.slides.length;
      const next = ((index % n) + n) % n;
      this.setActive(next);
      if (userAction && this.playing) this.startTimer();
    }

    startTimer() {
      this.pauseTimer();
      if (!this.playing) return;
      this.timer = setInterval(() => this.go(this.current + 1, false), this.interval);
    }

    pauseTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    }

    toggle() {
      this.playing = !this.playing;
      if (this.playpause) {
        this.playpause.dataset.state = this.playing ? 'playing' : 'paused';
        const label = this.playing ? this.playpause.dataset.labelPause : this.playpause.dataset.labelPlay;
        if (label) this.playpause.setAttribute('aria-label', label);
      }
      if (this.playing) this.startTimer();
      else this.pauseTimer();
    }
  }

  if (!customElements.get('hero-carousel-034')) {
    customElements.define('hero-carousel-034', HeroCarousel034);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lead-popup-034"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('lead-popup-034')) {
    const SENT_KEY = 'outlet034:leadpopup:sent';

    class LeadPopup034 extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[ref="dialog"]');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;

        this.form = this.querySelector('[ref="form"]');
        this.storageKey = 'outlet034:leadpopup';
        this.designMode = this.dataset.designMode === 'true';
        this.frequencyDays = parseInt(this.dataset.frequencyDays, 10) || 0;
        this.opened = false;

        this.ref('close')?.addEventListener('click', () => this.close());
        this.ref('successClose')?.addEventListener('click', () => this.close());
        this.ref('copy')?.addEventListener('click', () => this.copyCoupon());
        this.dialog.addEventListener('click', (e) => {
          if (e.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('close', () => this.releaseScroll());

        if (this.form) {
          this.form.addEventListener('submit', (e) => this.onSubmit(e));
          this.bindBirth();
          this.bindPhone();
        }

        // Retorno de um envio feito PELO pop-up (marca em sessionStorage).
        const sentByPopup = this.readSent();
        if (sentByPopup) {
          this.clearSent();
          if (this.ref('posted')?.dataset.posted === 'true') {
            this.clearDraft();
            this.showSuccess();
            this.open(false);
            return;
          }
          if (this.querySelector('[data-server-error]')) {
            this.restoreDraft();
            this.open(false);
            return;
          }
        }

        if (this.designMode) {
          if (this.dataset.previewSuccess === 'true') this.showSuccess();
          this.open(false);
          return;
        }
        if (this.shouldSkip()) return;

        this.scheduleTriggers();
      }

      ref(name) {
        return this.querySelector('[ref="' + name + '"]');
      }

      value(name) {
        const el = this.ref(name);
        return el ? (el.value || '').trim() : '';
      }

      /* ---------- storage ---------- */
      readSent() {
        try {
          return window.sessionStorage.getItem(SENT_KEY) === '1';
        } catch (e) {
          return false;
        }
      }
      clearSent() {
        try {
          window.sessionStorage.removeItem(SENT_KEY);
        } catch (e) {}
      }

      clearDraft() {
        try {
          window.sessionStorage.removeItem(SENT_KEY + ':draft');
        } catch (e) {}
      }
      markSent() {
        try {
          window.sessionStorage.setItem(SENT_KEY, '1');
          const draft = {};
          ['name', 'email', 'birthDay', 'birthMonth', 'birthYear', 'phone'].forEach((r) => (draft[r] = this.value(r)));
          window.sessionStorage.setItem(SENT_KEY + ':draft', JSON.stringify(draft));
        } catch (e) {}
      }

      // Em caso de erro do servidor, devolve o que a pessoa digitou.
      restoreDraft() {
        try {
          const draft = JSON.parse(window.sessionStorage.getItem(SENT_KEY + ':draft') || '{}');
          Object.keys(draft).forEach((r) => {
            const el = this.ref(r);
            if (el && draft[r]) el.value = draft[r];
          });
        } catch (e) {}
      }

      shouldSkip() {
        try {
          const last = parseInt(window.localStorage.getItem(this.storageKey), 10);
          if (!last) return false;
          return Date.now() - last < this.frequencyDays * 86400000;
        } catch (e) {
          return false;
        }
      }

      remember() {
        try {
          window.localStorage.setItem(this.storageKey, String(Date.now()));
        } catch (e) {}
      }

      /* ---------- gatilhos ---------- */
      scheduleTriggers() {
        const delay = parseInt(this.dataset.delay, 10);
        const scroll = parseInt(this.dataset.scroll, 10);

        this.onScroll = () => {
          const doc = document.documentElement;
          const scrollable = doc.scrollHeight - window.innerHeight;
          const pct = scrollable > 0 ? (window.scrollY / scrollable) * 100 : 100;
          if (pct >= scroll) this.open(true);
        };

        if (!isNaN(delay) && delay >= 0) {
          this.timer = window.setTimeout(() => this.open(true), delay * 1000);
        }
        if (!isNaN(scroll) && scroll > 0) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
        }
      }

      clearTriggers() {
        if (this.timer) window.clearTimeout(this.timer);
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      }

      open(persist) {
        if (this.opened) return;
        // Não sobrepõe outro modal/gaveta aberto (ex.: carrinho).
        if (persist && document.querySelector('dialog[open]')) {
          this.timer = window.setTimeout(() => this.open(persist), 4000);
          return;
        }
        this.opened = true;
        this.clearTriggers();
        this.previousFocus = document.activeElement;
        this.lockScroll();
        this.dialog.showModal();
        // Foco no próprio diálogo: não abre o teclado no mobile nem destaca o botão fechar.
        this.dialog.focus({ preventScroll: true });
        if (persist) this.remember();
      }

      close() {
        if (this.dialog.open) this.dialog.close();
        this.releaseScroll();
        if (this.previousFocus && typeof this.previousFocus.focus === 'function') {
          this.previousFocus.focus({ preventScroll: true });
        }
      }

      lockScroll() {
        const sbw = window.innerWidth - document.documentElement.clientWidth;
        if (sbw > 0) document.documentElement.style.paddingRight = sbw + 'px';
        document.documentElement.style.overflow = 'hidden';
      }

      releaseScroll() {
        document.documentElement.style.overflow = '';
        document.documentElement.style.paddingRight = '';
      }

      showSuccess() {
        const formState = this.ref('formState');
        const success = this.ref('success');
        if (!success) return;
        if (formState) formState.hidden = true;
        success.hidden = false;
        const title = this.ref('successTitle');
        if (title) this.dialog.setAttribute('aria-labelledby', title.id);
        requestAnimationFrame(() => (this.ref('copy') || title)?.focus({ preventScroll: true }));
      }

      /* ---------- cupom ---------- */
      async copyCoupon() {
        const code = (this.ref('couponCode')?.textContent || '').trim();
        const btn = this.ref('copy');
        if (!code || !btn) return;
        let ok = false;
        try {
          await navigator.clipboard.writeText(code);
          ok = true;
        } catch (e) {
          const tmp = document.createElement('textarea');
          tmp.value = code;
          tmp.setAttribute('readonly', '');
          tmp.style.cssText = 'position:fixed;opacity:0;';
          this.dialog.appendChild(tmp);
          tmp.select();
          try {
            ok = document.execCommand('copy');
          } catch (err) {}
          tmp.remove();
        }
        if (!ok) return;
        const copied = this.dataset.copiedLabel || '✓';
        btn.textContent = copied;
        const status = this.ref('copyStatus');
        if (status) status.textContent = copied;
        window.clearTimeout(this.copyTimer);
        this.copyTimer = window.setTimeout(() => {
          btn.textContent = btn.dataset.label;
          if (status) status.textContent = '';
        }, 2200);
      }

      /* ---------- data de nascimento ---------- */
      bindBirth() {
        const fields = [this.ref('birthDay'), this.ref('birthMonth'), this.ref('birthYear')].filter(Boolean);
        fields.forEach((input, i) => {
          input.addEventListener('input', () => {
            const raw = input.value;
            // Colar "01/02/1990" no primeiro campo distribui nos três.
            if (i === 0 && /\d{1,2}\D\d{1,2}\D\d{2,4}/.test(raw)) {
              const [d, m, y] = raw.split(/\D+/);
              fields[0].value = d.padStart(2, '0');
              fields[1].value = m.padStart(2, '0');
              fields[2].value = y.slice(0, 4);
              fields[2].focus();
              return;
            }
            input.value = raw.replace(/\D/g, '').slice(0, input.maxLength);
            input.removeAttribute('aria-invalid');
            if (input.value.length >= input.maxLength && fields[i + 1]) fields[i + 1].focus();
          });
          input.addEventListener('keydown', (e) => {
            if (e.key === 'Backspace' && !input.value && fields[i - 1]) {
              e.preventDefault();
              fields[i - 1].focus();
            }
          });
          input.addEventListener('blur', () => {
            if (i < 2 && input.value.length === 1 && input.value !== '0') input.value = '0' + input.value;
          });
        });
      }

      birthValue() {
        const d = this.value('birthDay');
        const m = this.value('birthMonth');
        const y = this.value('birthYear');
        if (!d && !m && !y) return { empty: true };
        const day = parseInt(d, 10);
        const month = parseInt(m, 10);
        const year = parseInt(y, 10);
        const now = new Date().getFullYear();
        if (y.length !== 4 || !day || !month || !year) return { valid: false };
        if (year < now - 110 || year > now - 10) return { valid: false };
        const date = new Date(year, month - 1, day);
        const valid = date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
        return {
          valid,
          text: String(day).padStart(2, '0') + '/' + String(month).padStart(2, '0') + '/' + year,
          month: String(month).padStart(2, '0'),
        };
      }

      /* ---------- telefone ---------- */
      bindPhone() {
        const phone = this.ref('phone');
        if (!phone) return;
        phone.addEventListener('input', () => {
          let digits = phone.value.replace(/\D/g, '');
          if (digits.length > 11 && digits.startsWith('55')) digits = digits.slice(2);
          phone.value = this.formatPhone(digits.slice(0, 11));
          phone.removeAttribute('aria-invalid');
        });
      }

      formatPhone(d) {
        if (!d) return '';
        if (d.length <= 2) return '(' + d;
        if (d.length <= 7) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
        return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
      }

      phoneValue() {
        const digits = this.value('phone').replace(/\D/g, '');
        if (!digits) return { empty: true };
        const valid = /^[1-9][1-9]9\d{8}$/.test(digits);
        return { valid, text: '+55 ' + this.formatPhone(digits) };
      }

      /* ---------- envio ---------- */
      showError(message, field) {
        const box = this.ref('clientError');
        const server = this.ref('serverError');
        if (server) server.hidden = true;
        if (box) {
          box.textContent = message;
          box.hidden = false;
        }
        if (field) {
          field.setAttribute('aria-invalid', 'true');
          field.focus();
        }
      }

      onSubmit(event) {
        const box = this.ref('clientError');
        if (box) box.hidden = true;

        const name = this.ref('name');
        const email = this.ref('email');
        const required = this.dataset.errorRequired;
        if (name && !name.value.trim()) {
          event.preventDefault();
          return this.showError(required, name);
        }
        if (email && (!email.value.trim() || !email.checkValidity())) {
          event.preventDefault();
          return this.showError(required, email);
        }

        const birth = this.birthValue();
        if ((birth.empty && this.dataset.requireBirth === 'true') || (!birth.empty && !birth.valid)) {
          event.preventDefault();
          ['birthMonth', 'birthYear'].forEach((r) => this.ref(r)?.setAttribute('aria-invalid', 'true'));
          return this.showError(this.dataset.errorBirth, this.ref('birthDay'));
        }

        const phone = this.phoneValue();
        if ((phone.empty && this.dataset.requirePhone === 'true') || (!phone.empty && !phone.valid)) {
          event.preventDefault();
          return this.showError(this.dataset.errorPhone, this.ref('phone'));
        }

        const parts = [];
        const tags = (this.dataset.baseTags || '')
          .split(',')
          .map((t) => t.trim())
          .filter(Boolean);
        if (!birth.empty) {
          parts.push('Nascimento: ' + birth.text);
          tags.push('aniversario-' + birth.month);
        }
        if (!phone.empty) {
          parts.push('Telefone: ' + phone.text);
          tags.push('lead-com-telefone');
        }
        if (this.dataset.sourceLabel) parts.push('Origem: ' + this.dataset.sourceLabel);

        const note = this.ref('note');
        if (note) note.value = parts.join(' | ');
        const tagInput = this.ref('tags');
        if (tagInput) tagInput.value = tags.join(', ');

        this.ref('submit')?.setAttribute('aria-busy', 'true');
        this.markSent();
        this.remember();
      }

      disconnectedCallback() {
        this.clearTriggers();
        this.releaseScroll();
      }
    }

    customElements.define('lead-popup-034', LeadPopup034);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-sticky-buy-034"] && !Shopify.designMode) return;
  try {
    
  class PdpStickyBuy034 extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('[ref="bar"]');
      // Kit por metafield OU por montador presente na página (ex.: modelo exclusivo de kit).
      this.isKit = this.dataset.kit === 'true' || !!document.querySelector('[data-kit034]');
      this.buyButton = this.querySelector('[ref="buyButton"]');
      this.priceEl = this.querySelector('[ref="price"]');
      if (!this.bar) return;

      this.setupObserver();
      this.mirrorPrice();
      if (this.buyButton) {
        if (this.isKit && this.dataset.kitLabel) this.buyButton.textContent = this.dataset.kitLabel;
        this.buyButton.addEventListener('click', () => this.triggerAddToCart());
      }
    }

    findTarget() {
      // Kit: observa o montador; produto normal: os botões de compra (fallback: seletor configurado).
      const candidates = [];
      if (this.isKit) candidates.push('[data-kit034]');
      candidates.push('product-form-component', this.dataset.targetSelector, '[data-testid="product-information-details"]');
      for (const sel of candidates) {
        if (!sel) continue;
        try {
          const el = document.querySelector(sel);
          if (el && el.getClientRects().length) return el;
        } catch (e) {
          /* seletor inválido salvo no editor: ignora */
        }
      }
      return null;
    }

    setVisible(visible) {
      if (this.bar.dataset.visible === String(visible)) return;
      this.bar.dataset.visible = visible ? 'true' : 'false';
      if (this.buyButton) this.buyButton.tabIndex = visible ? 0 : -1;
      this.bar.toggleAttribute('inert', !visible);
      document.documentElement.style.setProperty('--pdp-sticky-buy-height', visible ? `${this.bar.offsetHeight}px` : '0px');
      document.documentElement.classList.toggle('has-pdp-sticky-buy', visible);
    }

    setupObserver() {
      this.target = this.findTarget();
      this.setVisible(false);
      if (!this.target) return;
      // A barra aparece só depois que o alvo (botões de compra / montador do kit) saiu por CIMA da tela.
      this.update = () => {
        this.ticking = false;
        if (!this.target || !this.target.isConnected) this.target = this.findTarget();
        if (!this.target) return this.setVisible(false);
        this.setVisible(this.target.getBoundingClientRect().bottom < 0);
      };
      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(this.update);
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(() => this.onScroll(), { threshold: 0 });
        this.observer.observe(this.target);
      }
      this.update();
    }

    mirrorPrice() {
      const source = document.querySelector('.pdp-price-034');
      if (!source || !this.priceEl) return;
      const sync = () => { this.priceEl.innerHTML = source.innerHTML; };
      sync();
      this.priceObserver = new MutationObserver(sync);
      this.priceObserver.observe(source, { childList: true, subtree: true, characterData: true });
    }

    scrollToTarget(el) {
      if (!el) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const y = el.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
      const focusable = el.querySelector('button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), reduce ? 0 : 400);
    }

    triggerAddToCart() {
      if (this.isKit) {
        this.scrollToTarget(document.querySelector('[data-kit034]'));
        return;
      }
      const buttons = document.querySelectorAll('.add-to-cart-button, add-to-cart-component button, [ref="addToCartButton"]');
      for (const btn of buttons) {
        if (this.contains(btn) || !btn.getClientRects().length) continue;
        if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') {
          // Variante indisponível / não escolhida: leva o cliente ao seletor de tamanho.
          this.scrollToTarget(document.querySelector('.pdp-size-picker-034, variant-picker') || btn);
          return;
        }
        btn.click();
        return;
      }
      this.scrollToTarget(this.target);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.priceObserver) this.priceObserver.disconnect();
      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
      document.documentElement.classList.remove('has-pdp-sticky-buy');
      document.documentElement.style.removeProperty('--pdp-sticky-buy-height');
    }
  }
  if (!customElements.get('pdp-sticky-buy-034')) {
    customElements.define('pdp-sticky-buy-034', PdpStickyBuy034);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations-034"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations034 extends HTMLElement {
    connectedCallback() {
      if (this.dataset.performed === 'false' && this.dataset.url) {
        this.fetchRecommendations();
      } else {
        this.initCarousel();
      }
    }

    async fetchRecommendations() {
      try {
        const res = await fetch(this.dataset.url);
        if (!res.ok) return;
        const text = await res.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');
        const fresh = doc.querySelector('product-recommendations-034');
        if (fresh && fresh.querySelector('.pr034__item')) {
          this.innerHTML = fresh.innerHTML;
          this.initCarousel();
        } else {
          this.hideEmpty();
        }
      } catch (e) {
        this.hideEmpty();
      }
    }

    hideEmpty() {
      // Sem recomendações: não deixa um bloco vazio com padding na PDP.
      const section = this.closest('.shopify-section');
      if (section && !window.Shopify?.designMode) section.hidden = true;
      else this.hidden = true;
    }

    initCarousel() {
      this.track = this.querySelector('[ref="track"]');
      this.prev = this.querySelector('[ref="prev"]');
      this.next = this.querySelector('[ref="next"]');
      if (!this.track) return;

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const step = () => {
        const item = this.track.querySelector('.pr034__item');
        return item ? item.offsetWidth + parseInt(getComputedStyle(this.track).columnGap || '0', 10) : this.track.clientWidth;
      };

      if (this.prev) this.prev.addEventListener('click', () => {
        this.track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' });
      });
      if (this.next) this.next.addEventListener('click', () => {
        this.track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' });
      });

      this.onScroll = this.updateArrows.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.updateArrows();
    }

    updateArrows() {
      if (!this.track) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth - 1;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 0;
      if (this.next) this.next.disabled = this.track.scrollLeft >= maxScroll;
    }

    disconnectedCallback() {
      if (this.track && this.onScroll) this.track.removeEventListener('scroll', this.onScroll);
    }
  }
  if (!customElements.get('product-recommendations-034')) {
    customElements.define('product-recommendations-034', ProductRecommendations034);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-034"] && !Shopify.designMode) return;
  try {
    
  class ProductTabs034 extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.pt034__tab'));
      this.panels = Array.from(this.querySelectorAll('.pt034__panel'));
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.cleanups = [];

      this.tabs.forEach((tab) => {
        const onClick = () => this.select(Number(tab.dataset.index), true);
        const onKey = (e) => this.onTabKey(e);
        tab.addEventListener('click', onClick);
        tab.addEventListener('keydown', onKey);
        this.cleanups.push(() => {
          tab.removeEventListener('click', onClick);
          tab.removeEventListener('keydown', onKey);
        });
      });

      this.panels.forEach((panel) => this.setupCarousel(panel));
    }

    disconnectedCallback() {
      this.cleanups.forEach((fn) => fn());
      this.cleanups = [];
    }

    onTabKey(e) {
      const i = this.tabs.indexOf(e.currentTarget);
      let next = null;
      if (e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
      if (e.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
      if (e.key === 'Home') next = 0;
      if (e.key === 'End') next = this.tabs.length - 1;
      if (next === null) return;
      e.preventDefault();
      this.select(next, true);
      this.tabs[next].focus();
    }

    select(index, animate) {
      this.tabs.forEach((tab, i) => {
        const on = i === index;
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.tabIndex = on ? 0 : -1;
        if (on) tab.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: this.reduced ? 'auto' : 'smooth' });
      });
      this.panels.forEach((panel, i) => {
        const on = i === index;
        panel.hidden = !on;
        if (on) {
          const track = panel.querySelector('.pt034__track');
          if (track) track.scrollLeft = 0;
          if (animate && !this.reduced) {
            panel.classList.remove('is-entering');
            void panel.offsetWidth;
            panel.classList.add('is-entering');
          }
          /* Cards de abas ocultas não passaram pelo observer de entrada: revela já */
          if (track) track.classList.add('rv034--in');
          if (panel._pt034Update) panel._pt034Update();
        }
      });
    }

    setupCarousel(panel) {
      const track = panel.querySelector('.pt034__track');
      if (!track) return;
      const prev = panel.querySelector('.pt034__arrow--prev');
      const next = panel.querySelector('.pt034__arrow--next');
      const progress = panel.querySelector('.pt034__progress');
      const fill = panel.querySelector('.pt034__progress-fill');

      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        const x = track.scrollLeft;
        if (prev) prev.disabled = x <= 4;
        if (next) next.disabled = x >= max - 4;
        if (progress && fill) {
          const ratio = track.scrollWidth ? track.clientWidth / track.scrollWidth : 1;
          progress.classList.toggle('is-static', ratio >= 0.99);
          const w = Math.max(ratio * 100, 8);
          fill.style.width = w + '%';
          const pos = max > 0 ? x / max : 0;
          fill.style.transform = 'translateX(' + (pos * (100 / w * 100 - 100)) + '%)';
        }
      };
      panel._pt034Update = update;

      const step = (dir) => {
        const item = track.querySelector('.pt034__item');
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        const itemW = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
        const perPage = Math.max(1, Math.floor((track.clientWidth + gap) / itemW));
        track.scrollBy({ left: dir * itemW * perPage, behavior: this.reduced ? 'auto' : 'smooth' });
      };

      const onPrev = () => step(-1);
      const onNext = () => step(1);
      let raf = 0;
      const onScroll = () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(update);
      };
      if (prev) prev.addEventListener('click', onPrev);
      if (next) next.addEventListener('click', onNext);
      track.addEventListener('scroll', onScroll, { passive: true });
      const ro = new ResizeObserver(update);
      ro.observe(track);

      this.cleanups.push(() => {
        if (prev) prev.removeEventListener('click', onPrev);
        if (next) next.removeEventListener('click', onNext);
        track.removeEventListener('scroll', onScroll);
        ro.disconnect();
        cancelAnimationFrame(raf);
      });
      update();
    }
  }

  if (!customElements.get('product-tabs-034')) {
    customElements.define('product-tabs-034', ProductTabs034);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rastreio-034"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('order-tracker-034')) {
    class OrderTracker034 extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('[ref="form"]');
        this.input = this.querySelector('[ref="input"]');
        this.status = this.querySelector('[ref="status"]');
        this.orderHelp = this.querySelector('[ref="orderHelp"]');
        if (!this.form || !this.input) return;
        this.onSubmit = this.onSubmit.bind(this);
        this.form.addEventListener('submit', this.onSubmit);

        // Permite link direto: /pages/rastreio?codigo=AA123456789BR
        const params = new URLSearchParams(window.location.search);
        const preset = params.get('codigo') || params.get('code');
        if (preset) this.input.value = preset;
      }

      disconnectedCallback() {
        if (this.form) this.form.removeEventListener('submit', this.onSubmit);
      }

      say(text, isHtml) {
        if (!this.status) return;
        if (!text) {
          this.status.hidden = true;
          this.status.textContent = '';
          return;
        }
        this.status.hidden = false;
        if (isHtml) this.status.innerHTML = text;
        else this.status.textContent = text;
      }

      buildUrl(template, code) {
        if (!template) return '';
        const encoded = encodeURIComponent(code);
        return template.indexOf('{code}') > -1 ? template.split('{code}').join(encoded) : template + encoded;
      }

      onSubmit(event) {
        event.preventDefault();
        const raw = (this.input.value || '').trim();
        const code = raw.replace(/[\s.-]/g, '').toUpperCase();
        if (this.orderHelp) this.orderHelp.hidden = true;

        if (!code) {
          this.say(this.dataset.msgEmpty);
          this.input.focus();
          return;
        }

        const isCorreios = /^[A-Z]{2}\d{9}[A-Z]{2}$/.test(code);
        const isOrder = /^#?\d{3,10}$/.test(code);
        let url = '';
        if (isCorreios) url = this.buildUrl(this.dataset.correiosUrl, code);
        else if (!isOrder) url = this.buildUrl(this.dataset.appUrl, code);

        if (url) {
          // Sem 'noopener' nas features (senão window.open sempre retorna null); zera o opener manualmente.
          const win = window.open(url, '_blank');
          if (win) win.opener = null;
          const link = '<a href="' + url.replace(/"/g, '&quot;') + '" target="_blank" rel="noopener">' + code + '</a>';
          const msg = (this.dataset.msgOpened || '').replace('{code}', link);
          this.say(msg || link, true);
          if (!win) window.location.href = url;
          return;
        }

        // Número de pedido (ou código sem rastreio externo): orienta acessar a conta.
        this.say((this.dataset.msgOrder || '').replace('{code}', raw));
        if (this.orderHelp) this.orderHelp.hidden = false;
      }
    }
    customElements.define('order-tracker-034', OrderTracker034);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-collections-034"] && !Shopify.designMode) return;
  try {
    
  class Vidcol034Carousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[ref="track"]');
      if (!this.track) return;
      this.prevBtn = this.querySelector('[ref="prev"]');
      this.nextBtn = this.querySelector('[ref="next"]');
      this.cards = Array.from(this.track.querySelectorAll('.vidcol-034__card'));
      this.count = parseInt(this.dataset.count || '0', 10) || this.cards.length;
      this.loop = this.dataset.loop === 'true';
      this.playMode = this.dataset.playMode || 'visible';
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.saveData = !!(navigator.connection && navigator.connection.saveData);
      this.autoVideo = !this.reduce && !this.saveData;
      this.userPaused = new WeakSet();
      this.visible = new Set();
      this.center = null;

      this.scrolling = false;
      this.dragging = false;
      this.holdUntil = 0;
      this.lastScroll = 0;
      this.onPrev = () => { this.interacted(); this.step(-1); };
      this.onNext = () => { this.interacted(); this.step(1); };
      this.onScroll = () => this.queue();
      this.onDown = () => { this.dragging = true; this.dragSince = Date.now(); this.interacted(); };
      this.onUp = () => {
        if (!this.dragging) return;
        this.dragging = false;
        this.interacted();
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.settle(), 160);
      };
      this.onWheel = (e) => { if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) { this.lastWheel = Date.now(); this.interacted(); } };
      this.onScrollEnd = () => { if (this.dragging) return; clearTimeout(this.settleTimer); this.settle(); };
      this.onClick = (e) => this.handleControl(e);
      this.onResize = () => this.jumpTo(this.centerIndex(), false);
      this.onVisibility = () => {
        if (document.hidden) {
          this.stopAuto();
          this.pauseAll();
        } else {
          this.syncVideos();
          this.startAuto();
        }
      };

      if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      this.track.addEventListener('click', this.onClick);
      ['pointerdown', 'touchstart'].forEach((t) => this.track.addEventListener(t, this.onDown, { passive: true }));
      // Soltar é ouvido na janela: o gesto pode terminar fora do trilho.
      ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach((t) => window.addEventListener(t, this.onUp, { passive: true }));
      this.track.addEventListener('wheel', this.onWheel, { passive: true });
      if ('onscrollend' in window) this.track.addEventListener('scrollend', this.onScrollEnd);
      window.addEventListener('resize', this.onResize, { passive: true });
      document.addEventListener('visibilitychange', this.onVisibility);
      this.setupViewer();

      // Posição inicial: primeiro card original no centro (sem animação).
      const startAt = this.loop ? this.count : 0;
      requestAnimationFrame(() => {
        this.jumpTo(startAt, false);
        this.spotlight();
        this.updateArrows();
      });
      this.onLoad = () => { if (!this.scrolling && !this.dragging) this.jumpTo(this.loop ? this.count + this.realIndex(this.centerIndex()) : this.centerIndex(), false); };
      window.addEventListener('load', this.onLoad);

      // Vídeos: só tocam quando o card aparece na tela.
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            if (en.isIntersecting && en.intersectionRatio >= 0.8) this.visible.add(en.target);
            else this.visible.delete(en.target);
          });
          this.syncVideos();
        }, { threshold: [0, 0.8, 1] });
        this.cards.forEach((c) => { if (c.querySelector('video')) this.io.observe(c); });
      }

      // Carrossel automático (opcional): um card por vez. Pausa só com gesto real
      // (toque, arrasto, roda, setas, foco do teclado) e retoma após alguns segundos.
      this.interval = parseInt(this.dataset.interval || '4000', 10);
      this.autoOn = this.dataset.autoplay === 'true' && !this.reduce;
      this.sectionVisible = false;
      // Só o foco do TECLADO segura o autoplay; clique/toque deixa foco no botão e não pode travar o carrossel.
      this.onFocusIn = (e) => { this.focusInside = !!(e.target && e.target.matches && e.target.matches(':focus-visible')); };
      this.onFocusOut = () => { this.focusInside = false; };
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      if ('IntersectionObserver' in window) {
        this.ioSection = new IntersectionObserver((en) => { this.sectionVisible = en[0].isIntersecting; }, { threshold: 0.3 });
        this.ioSection.observe(this.track);
      } else {
        this.sectionVisible = true;
      }
      if (this.autoOn) this.startAuto();
    }

    disconnectedCallback() {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
      if (this.track) {
        this.track.removeEventListener('scroll', this.onScroll);
        this.track.removeEventListener('click', this.onClick);
        ['pointerdown', 'touchstart'].forEach((t) => this.track.removeEventListener(t, this.onDown));
        this.track.removeEventListener('wheel', this.onWheel);
        this.track.removeEventListener('scrollend', this.onScrollEnd);
      }
      ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach((t) => window.removeEventListener(t, this.onUp));
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('load', this.onLoad);
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.removeEventListener('focusin', this.onFocusIn);
      this.removeEventListener('focusout', this.onFocusOut);
      if (this.io) this.io.disconnect();
      if (this.ioSection) this.ioSection.disconnect();
      clearTimeout(this.settleTimer);
      clearTimeout(this.checkTimer);
      cancelAnimationFrame(this.raf);
      this.stopAuto();
      this.pauseAll();
      this.teardownViewer();
    }

    /* ---------- Geometria (offsetLeft: não muda com a escala do card central) ---------- */
    cardCenter(card) {
      return card.offsetLeft + card.offsetWidth / 2;
    }

    leftFor(card) {
      return this.cardCenter(card) - this.track.clientWidth / 2;
    }

    centerIndex() {
      const mid = this.track.scrollLeft + this.track.clientWidth / 2;
      let best = 0;
      let min = Infinity;
      this.cards.forEach((c, i) => {
        const d = Math.abs(this.cardCenter(c) - mid);
        if (d < min) { min = d; best = i; }
      });
      return best;
    }

    realIndex(i) {
      return this.loop ? ((i % this.count) + this.count) % this.count : i;
    }

    // Mexe na posição sem animação e sem o encaixe (snap) interferir.
    instant(fn) {
      const t = this.track;
      t.style.scrollSnapType = 'none';
      t.style.scrollBehavior = 'auto';
      fn();
      void t.offsetWidth;
      t.style.scrollSnapType = '';
      t.style.scrollBehavior = '';
    }

    jumpTo(i, smooth) {
      const card = this.cards[Math.max(0, Math.min(i, this.cards.length - 1))];
      if (!card) return;
      const left = this.leftFor(card);
      if (smooth && !this.reduce) this.track.scrollTo({ left, behavior: 'smooth' });
      else this.instant(() => { this.track.scrollLeft = left; });
    }

    // Um passo por vez: enquanto a rolagem anterior não assentou, ignora (não empilha nem pula cards).
    step(dir) {
      if (this.scrolling || this.dragging) return;
      let i = this.centerIndex() + dir;
      if (!this.loop) {
        if (i < 0 || i > this.cards.length - 1) i = dir > 0 ? 0 : this.cards.length - 1;
      }
      const target = this.cards[Math.max(0, Math.min(i, this.cards.length - 1))];
      if (!target) return;
      const dest = this.leftFor(target);
      this.scrolling = true;
      this.lastScroll = Date.now();
      this.jumpTo(i, true);
      // Safari às vezes cancela a animação num trilho com snap: confere e vai direto.
      clearTimeout(this.checkTimer);
      this.checkTimer = setTimeout(() => {
        const now = this.cards[this.centerIndex()];
        if (!this.dragging && Math.abs(this.track.scrollLeft - dest) > 4 && this.realIndex(this.cards.indexOf(now)) !== this.realIndex(i)) {
          this.instant(() => { this.track.scrollLeft = dest; });
          this.settle();
        }
      }, 1500);
    }

    queue() {
      this.scrolling = true;
      this.lastScroll = Date.now();
      if (!this.raf) {
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.spotlight();
          this.updateArrows();
        });
      }
      // Roda/trackpad: a volta do loop acontece na hora (sem pausa de 160ms o gesto chegaria ao fim das cópias).
      if (this.lastWheel && Date.now() - this.lastWheel < 350) this.normalize();
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.settle(), 160);
    }

    settle() {
      if (this.dragging) return;
      this.scrolling = false;
      this.normalize();
      this.spotlight();
      this.updateArrows();
    }

    // Loop infinito: fora do bloco do meio, salta um ciclo inteiro para o "gêmeo" (mesmo pixel, invisível).
    normalize() {
      if (!this.loop || this.dragging) return;
      const n = this.count;
      const first = this.cards[n];
      const twin = this.cards[n * 2];
      if (!first || !twin) return;
      const cycle = twin.offsetLeft - first.offsetLeft;
      const base = this.leftFor(first);
      const x = this.track.scrollLeft;
      let nx = null;
      if (x >= base + cycle - 1) nx = x - cycle;
      else if (x < base - 1) nx = x + cycle;
      if (nx === null) return;
      const before = this.center && this.center.querySelector('video');
      const t = before && !before.paused ? before.currentTime : null;
      this.track.classList.add('is-quiet');
      this.instant(() => { this.track.scrollLeft = nx; });
      this.center = null;
      this.spotlight();
      requestAnimationFrame(() => requestAnimationFrame(() => this.track.classList.remove('is-quiet')));
      const after = this.center && this.center.querySelector('video');
      if (after && before && after !== before && t != null) {
        const seek = () => { try { after.currentTime = t; } catch (e) {} };
        if (after.readyState >= 1) seek(); else after.addEventListener('loadedmetadata', seek, { once: true });
      }
    }

    interacted() {
      this.holdUntil = Date.now() + 6000;
      this.arrivedAt = Date.now();
    }

    spotlight() {
      const i = this.centerIndex();
      const card = this.cards[i];
      if (card === this.center) return;
      this.cards.forEach((c) => c.classList.toggle('is-center', c === card));
      this.center = card;
      // Som "segue" o card em destaque depois que o visitante o ativou.
      if (this.soundOn) {
        this.cards.forEach((c) => {
          const v = c.querySelector('video');
          if (!v) return;
          v.muted = c !== card;
          if (c === card) { this.userPaused.delete(v); v.dataset.userPlay = '1'; }
        });
      }
      this.syncVideos();
    }

    updateArrows() {
      if (this.loop) return;
      const max = this.track.scrollWidth - this.track.clientWidth - 2;
      if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 2;
      if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= max;
    }

    // Relógio do autoplay: conta o tempo desde que o card CHEGOU ao meio e só anda
    // com tudo parado. Vigia estados presos (rolagem sem evento, soltar perdido).
    startAuto() {
      if (this.viewerOpen) return;
      if (!this.autoOn || this.timer || document.hidden) return;
      this.arrivedAt = Date.now();
      this.timer = setInterval(() => {
        const now = Date.now();
        if (this.scrolling && now - this.lastScroll > 1000) this.settle();
        if (this.dragging && now - (this.dragSince || 0) > 8000) { this.dragging = false; this.settle(); }
        const real = this.center ? this.realIndex(this.cards.indexOf(this.center)) : -1;
        if (real !== this.clockCard) { this.clockCard = real; this.arrivedAt = now; }
        const hold = this.viewerOpen || this.dragging || this.scrolling || !this.sectionVisible || document.hidden
          || now < this.holdUntil || this.focusInside || this.soundOn;
        if (hold) { this.arrivedAt = now; return; }
        if (now - this.arrivedAt >= this.interval) { this.arrivedAt = now; this.step(1); }
      }, 250);
    }

    stopAuto() {
      if (this.timer) { clearInterval(this.timer); this.timer = null; }
    }

    /* ---------- Vídeos ---------- */
    shouldPlay(card) {
      const video = card.querySelector('video');
      if (!video || this.userPaused.has(video)) return false;
      if (!this.visible.has(card) || document.hidden) return false;
      if (this.playMode === 'center') return card === this.center;
      return true;
    }

    syncVideos() {
      if (this.viewerOpen) return;
      this.cards.forEach((card) => {
        const video = card.querySelector('video');
        if (!video) return;
        const wantsPlay = (this.autoVideo || video.dataset.userPlay === '1') && this.shouldPlay(card);
        if (wantsPlay) this.play(video);
        else if (!video.paused) video.pause();
        this.renderState(card);
      });
    }

    play(video) {
      if (!video.paused) return;
      if (video.preload === 'none') video.preload = 'auto';
      const p = video.play();
      if (p && p.catch) p.catch(() => {});
      if (!video.dataset.bound) {
        video.dataset.bound = '1';
        video.addEventListener('playing', () => { video.classList.add('is-playing'); this.renderState(video.closest('.vidcol-034__card')); });
        video.addEventListener('pause', () => this.renderState(video.closest('.vidcol-034__card')));
      }
    }

    pauseAll() {
      this.cards.forEach((c) => { const v = c.querySelector('video'); if (v && !v.paused) v.pause(); });
    }

    renderState(card) {
      if (!card) return;
      const video = card.querySelector('video');
      const name = card.getAttribute('aria-label') || '';
      const playBtn = card.querySelector('[data-action="play"]');
      const soundBtn = card.querySelector('[data-action="sound"]');
      if (playBtn && video) {
        const paused = video.paused;
        playBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        playBtn.setAttribute('aria-label', (paused ? this.dataset.labelPlay : this.dataset.labelPause) + (name ? ': ' + name : ''));
      }
      if (soundBtn && video) {
        const on = !video.muted;
        soundBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
        soundBtn.setAttribute('aria-label', (on ? this.dataset.labelSoundOff : this.dataset.labelSoundOn) + (name ? ': ' + name : ''));
      }
    }

    /* ================= Visualizador (stories) ================= */
    setupViewer() {
      this.viewer = this.querySelector('[ref="viewer"]');
      if (!this.viewer) return;
      this.vwVideo = this.viewer.querySelector('.vidcol-034__vw-video');
      this.vwStage = this.viewer.querySelector('.vidcol-034__vw-stage');
      this.vwTitle = this.viewer.querySelector('[data-vw-title]');
      this.vwCta = this.viewer.querySelector('[data-vw-cta]');
      this.vwBar = this.viewer.querySelector('.vidcol-034__vw-progress span');
      this.vwPlay = this.viewer.querySelector('[data-vw="play"]');
      this.vwSound = this.viewer.querySelector('[data-vw="sound"]');
      this.vwTap = this.viewer.querySelector('[data-vw="toggle"]');
      // Itens únicos (sem os clones do loop infinito), na ordem do editor.
      this.vwItems = this.cards.filter((c) => !c.classList.contains('is-clone') && c.querySelector('video'));

      this.onVwClick = (e) => {
        const t = e.target.closest('[data-vw]');
        if (e.target === this.viewer || e.target.classList.contains('vidcol-034__vw-shell')) return this.closeViewer(); // clique no fundo
        if (!t) return;
        const a = t.dataset.vw;
        if (a === 'close') this.closeViewer();
        else if (a === 'prev') this.vwGo(-1);
        else if (a === 'next') this.vwGo(1);
        else if (a === 'toggle' || a === 'play') this.vwToggle();
        else if (a === 'sound') { this.vwVideo.muted = !this.vwVideo.muted; this.vwRender(); }
      };
      this.onVwKey = (e) => {
        if (e.key === 'ArrowRight') { e.preventDefault(); this.vwGo(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); this.vwGo(-1); }
      };
      this.onVwClose = () => this.afterViewerClose();
      this.onVwTime = () => {
        const v = this.vwVideo;
        if (v.duration) this.vwBar.style.transform = 'scaleX(' + (v.currentTime / v.duration) + ')';
      };
      this.onVwState = () => this.vwRender();

      // Swipe: horizontal troca de vídeo; para baixo fecha (mobile).
      this.onVwDown = (e) => { this.vwStart = { x: e.clientX, y: e.clientY, t: Date.now() }; };
      this.onVwUp = (e) => {
        const st = this.vwStart; this.vwStart = null;
        if (!st) return;
        const dx = e.clientX - st.x, dy = e.clientY - st.y;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { this.vwSuppressTap = true; this.vwGo(dx < 0 ? 1 : -1); }
        else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) { this.vwSuppressTap = true; this.closeViewer(); }
      };
      this.onVwTapCapture = (e) => {
        if (this.vwSuppressTap) { this.vwSuppressTap = false; e.stopPropagation(); e.preventDefault(); }
      };

      this.viewer.addEventListener('click', this.onVwClick);
      this.viewer.addEventListener('keydown', this.onVwKey);
      this.viewer.addEventListener('close', this.onVwClose);
      this.vwVideo.addEventListener('timeupdate', this.onVwTime);
      ['play', 'pause', 'volumechange'].forEach((ev) => this.vwVideo.addEventListener(ev, this.onVwState));
      this.vwStage.addEventListener('pointerdown', this.onVwDown);
      this.vwStage.addEventListener('pointerup', this.onVwUp);
      this.vwTap.addEventListener('click', this.onVwTapCapture, true);
    }

    teardownViewer() {
      if (!this.viewer) return;
      this.viewer.removeEventListener('click', this.onVwClick);
      this.viewer.removeEventListener('keydown', this.onVwKey);
      this.viewer.removeEventListener('close', this.onVwClose);
      this.vwVideo.removeEventListener('timeupdate', this.onVwTime);
      ['play', 'pause', 'volumechange'].forEach((ev) => this.vwVideo.removeEventListener(ev, this.onVwState));
      this.vwStage.removeEventListener('pointerdown', this.onVwDown);
      this.vwStage.removeEventListener('pointerup', this.onVwUp);
      this.vwTap.removeEventListener('click', this.onVwTapCapture, true);
      if (this.viewer.open) this.viewer.close();
    }

    // Melhor fonte para tela cheia: a maior com altura <= 1280px (mp4).
    vwSource(card) {
      const sources = Array.from(card.querySelectorAll('video source'));
      if (!sources.length) return '';
      let best = null;
      sources.forEach((src) => {
        const h = parseInt(src.dataset.h || '0', 10);
        if (!best || (h <= 1280 && h > best.h) || (best.h > 1280 && h < best.h)) best = { url: src.src || src.getAttribute('src'), h };
      });
      return best ? best.url : '';
    }

    openViewer(card) {
      if (!this.viewer) return;
      const base = card.classList.contains('is-clone')
        ? this.vwItems.find((c) => c.dataset.index === card.dataset.index)
        : card;
      this.vwIndex = Math.max(0, this.vwItems.indexOf(base));
      this.vwReturn = document.activeElement;
      this.stopAuto();
      this.pauseAll();
      this.viewerOpen = true;
      this.prevOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.viewer.showModal();
      this.vwLoad(true);
      const closeBtn = this.viewer.querySelector('[data-vw="close"]');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }

    vwLoad(withSound) {
      const card = this.vwItems[this.vwIndex];
      if (!card) return;
      const v = this.vwVideo;
      const cardVideo = card.querySelector('video');
      const name = card.getAttribute('aria-label') || '';
      const link = card.querySelector('.vidcol-034__card-link');
      this.vwTitle.textContent = name;
      if (link && link.getAttribute('href')) { this.vwCta.href = link.getAttribute('href'); this.vwCta.hidden = false; }
      else this.vwCta.hidden = true;
      this.vwStage.classList.add('is-changing');
      v.poster = (cardVideo && cardVideo.getAttribute('poster')) || '';
      v.src = this.vwSource(card);
      if (withSound !== undefined) v.muted = !withSound;
      v.currentTime = 0;
      this.vwBar.style.transform = 'scaleX(0)';
      const p = v.play();
      const show = () => this.vwStage.classList.remove('is-changing');
      if (p && p.then) p.then(show).catch(() => { v.muted = true; v.play().catch(() => {}); show(); });
      else show();
      this.vwRender();
    }

    vwGo(dir) {
      if (!this.viewerOpen || this.vwItems.length < 2) return;
      this.vwIndex = (this.vwIndex + dir + this.vwItems.length) % this.vwItems.length;
      this.vwLoad();
    }

    vwToggle() {
      const v = this.vwVideo;
      if (v.paused) v.play().catch(() => {}); else v.pause();
    }

    vwRender() {
      const v = this.vwVideo;
      const d = this.dataset;
      if (this.vwPlay) {
        this.vwPlay.setAttribute('aria-pressed', v.paused ? 'true' : 'false');
        this.vwPlay.setAttribute('aria-label', v.paused ? d.labelPlay : d.labelPause);
      }
      if (this.vwTap) this.vwTap.setAttribute('aria-label', v.paused ? d.labelPlay : d.labelPause);
      if (this.vwSound) {
        this.vwSound.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
        this.vwSound.setAttribute('aria-label', v.muted ? d.labelSoundOn : d.labelSoundOff);
      }
    }

    closeViewer() {
      if (this.viewer && this.viewer.open) this.viewer.close();
    }

    afterViewerClose() {
      const v = this.vwVideo;
      v.pause();
      v.removeAttribute('src');
      v.load();
      this.viewerOpen = false;
      document.documentElement.style.overflow = this.prevOverflow || '';
      if (this.vwReturn && this.vwReturn.focus) this.vwReturn.focus({ preventScroll: true });
      this.syncVideos();
      this.startAuto();
    }

    handleControl(e) {
      const btn = e.target.closest('.vidcol-034__ctrl');
      if (!btn) return;
      e.preventDefault();
      const card = btn.closest('.vidcol-034__card');
      const video = card && card.querySelector('video');
      if (!video) return;
      const action = btn.dataset.action;

      if (action === 'play') {
        if (video.paused) {
          this.userPaused.delete(video);
          video.dataset.userPlay = '1';
          this.play(video);
        } else {
          this.userPaused.add(video);
          video.pause();
        }
      } else if (action === 'sound') {
        const unmute = video.muted;
        // Só um card com som por vez.
        if (unmute) this.cards.forEach((c) => { const v = c.querySelector('video'); if (v && v !== video) v.muted = true; this.renderState(c); });
        video.muted = !unmute;
        this.soundOn = unmute;
        if (unmute) { this.userPaused.delete(video); video.dataset.userPlay = '1'; this.play(video); }
      } else if (action === 'expand') {
        this.openViewer(card);
        return;
      }
      this.renderState(card);
    }
  }

  if (!customElements.get('vidcol-034-carousel')) {
    customElements.define('vidcol-034-carousel', Vidcol034Carousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-embed-034"] && !Shopify.designMode) return;
  try {
    
  class YoutubeFacade034 extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('.ytembed-034__poster');
      if (!this.button) return;
      this.onClick = this.load.bind(this);
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onClick);
    }

    load() {
      const id = this.dataset.videoId;
      if (!id) return;
      const iframe = document.createElement('iframe');
      iframe.setAttribute('allow', 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', this.dataset.label || 'YouTube');
      iframe.src =
        'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      this.innerHTML = '';
      this.appendChild(iframe);
    }
  }

  if (!customElements.get('youtube-facade-034')) {
    customElements.define('youtube-facade-034', YoutubeFacade034);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-034"] && !Shopify.designMode) return;
  try {
    
  /*
   * Página de Favoritos. Lê o localStorage DIRETAMENTE (mesma chave do
   * assets/wishlist-034.js) — não depende da ordem de carregamento do script
   * deferido. Reage a `wishlist:change` (mesma aba) e `storage` (outras abas).
   */
  class WishlistPage034 extends HTMLElement {
    static KEY = 'outlet034:wishlist';

    connectedCallback() {
      this.grid = this.querySelector('[ref="grid"]');
      this.loadingEl = this.querySelector('[ref="loading"]');
      this.emptyEl = this.querySelector('[ref="empty"]');
      let cfg = {};
      try {
        cfg = JSON.parse(this.querySelector('[data-wl034-config]').textContent);
      } catch (e) {
        cfg = {};
      }
      this.cfg = cfg;
      this.rendered = '';
      this.onChange = this.onChange.bind(this);
      this.onStorage = this.onStorage.bind(this);
      document.addEventListener('wishlist:change', this.onChange);
      window.addEventListener('storage', this.onStorage);
      this.render();
    }

    disconnectedCallback() {
      document.removeEventListener('wishlist:change', this.onChange);
      window.removeEventListener('storage', this.onStorage);
    }

    readHandles() {
      try {
        const raw = window.localStorage.getItem(WishlistPage034.KEY);
        const arr = raw ? JSON.parse(raw) : [];
        return Array.isArray(arr) ? arr.filter((h) => typeof h === 'string' && h) : [];
      } catch (e) {
        return [];
      }
    }

    onStorage(event) {
      if (event.key && event.key !== WishlistPage034.KEY) return;
      this.onChange();
    }

    onChange() {
      const handles = this.readHandles();
      // Remoções: tira só os cards que saíram (sem recarregar a grade).
      this.grid.querySelectorAll('[data-product-handle]').forEach((card) => {
        if (handles.indexOf(card.getAttribute('data-product-handle')) === -1) card.remove();
      });
      // Adições (ex.: outra aba): busca os que faltam.
      const shown = Array.from(this.grid.querySelectorAll('[data-product-handle]')).map((c) =>
        c.getAttribute('data-product-handle')
      );
      const missing = handles.filter((h) => shown.indexOf(h) === -1);
      if (missing.length) {
        this.append(missing);
      } else if (!this.grid.children.length) {
        this.showEmpty();
      }
    }

    showEmpty() {
      this.loadingEl.hidden = true;
      this.grid.hidden = true;
      this.emptyEl.hidden = false;
    }

    showGrid() {
      this.loadingEl.hidden = true;
      this.emptyEl.hidden = true;
      this.grid.hidden = false;
    }

    async fetchProducts(handles) {
      const products = await Promise.all(
        handles.map((handle) =>
          fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
            .then((r) => (r.ok ? r.json() : null))
            .catch(() => null)
        )
      );
      return products.filter(Boolean);
    }

    async render() {
      const handles = this.readHandles();
      if (!handles.length) {
        this.showEmpty();
        return;
      }
      await this.append(handles);
    }

    async append(handles) {
      const valid = await this.fetchProducts(handles);
      const start = this.grid.children.length;
      valid.forEach((product, i) => {
        if (this.grid.querySelector('[data-product-handle="' + CSS.escape(product.handle) + '"]')) return;
        this.grid.insertAdjacentHTML('beforeend', this.cardMarkup(product, start + i));
      });
      if (!this.grid.children.length) {
        this.showEmpty();
        return;
      }
      this.showGrid();
      if (window.Outlet034Wishlist) {
        window.Outlet034Wishlist.hydrate(this.grid);
      } else {
        // Script global ainda não rodou: marca os corações como ativos
        // (todos aqui estão favoritados por definição).
        this.grid.querySelectorAll('[data-wishlist-toggle]').forEach((btn) => {
          btn.setAttribute('aria-pressed', 'true');
          if (this.cfg.removeLabel) btn.setAttribute('aria-label', this.cfg.removeLabel);
        });
      }
    }

    money(cents) {
      if (window.Outlet034Wishlist) return window.Outlet034Wishlist.formatMoney(cents);
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'BRL';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {
          style: 'currency',
          currency,
        }).format((cents || 0) / 100);
      } catch (e) {
        return ((cents || 0) / 100).toFixed(2);
      }
    }

    esc(str) {
      const d = document.createElement('div');
      d.textContent = str == null ? '' : String(str);
      return d.innerHTML.replace(/"/g, '&quot;');
    }

    sized(url, width) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    cardMarkup(p, index) {
      const cfg = this.cfg;
      const price = p.price || 0;
      const compare = p.compare_at_price || 0;
      const hasCompare = compare > price;
      const soldOut = p.available === false;
      const discountPct = hasCompare ? Math.floor(((compare - price) * 100) / compare) : 0;

      let isNew = false;
      if (cfg.showNewBadge) {
        const tags = (p.tags || []).map((t) => String(t).toLowerCase());
        if (tags.indexOf('novo') !== -1) {
          isNew = true;
        } else if (p.published_at && cfg.newDays > 0) {
          const age = (Date.now() - new Date(p.published_at).getTime()) / 86400000;
          if (age < cfg.newDays) isNew = true;
        }
      }

      const pixPercent = parseInt(cfg.pix, 10) || 0;
      const pixPrice = Math.floor((price * (100 - pixPercent)) / 100);

      let parcelas = parseInt(cfg.parcelas, 10) || 1;
      const min = parseInt(cfg.parcelaMin, 10) || 0;
      if (min > 0) parcelas = Math.min(parcelas, Math.floor(price / min));
      const showInstallments = cfg.showInstallments && parcelas >= 2 && cfg.installmentsText;

      const imgPrimary = p.featured_image || (p.images && p.images[0]) || '';
      const imgSecondary = p.images && p.images[1] ? p.images[1] : '';
      const loading = index < 4 ? 'eager' : 'lazy';
      const title = this.esc(p.title);
      const url = this.esc(p.url);

      let badge = '';
      if (soldOut && cfg.soldoutLabel) {
        badge = '<span class="pc034__badge pc034__badge--soldout">' + this.esc(cfg.soldoutLabel) + '</span>';
      } else if (hasCompare) {
        badge = '<span class="pc034__badge pc034__badge--off">' + discountPct + this.esc(cfg.offSuffix || '') + '</span>';
      } else if (isNew && cfg.newLabel) {
        badge = '<span class="pc034__badge pc034__badge--new">' + this.esc(cfg.newLabel) + '</span>';
      }

      let imgHtml = '';
      if (imgPrimary) {
        imgHtml =
          '<img class="pc034__img pc034__img--primary" src="' + this.esc(this.sized(imgPrimary, 610)) +
          '" alt="' + title + '" loading="' + loading + '" width="305" height="380">';
        if (imgSecondary) {
          imgHtml +=
            '<img class="pc034__img pc034__img--secondary" src="' + this.esc(this.sized(imgSecondary, 610)) +
            '" alt="" loading="lazy" width="305" height="380">';
        }
      }

      const wishBtn =
        '<button type="button" class="pc034__wishlist" data-wishlist-toggle data-wishlist-handle="' + this.esc(p.handle) +
        '" data-label-add="' + this.esc(cfg.addLabel) + '" data-label-remove="' + this.esc(cfg.removeLabel) +
        '" aria-pressed="true" aria-label="' + this.esc(cfg.removeLabel) + '">' +
        '<svg class="pc034__wishlist-icon" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor"' +
        ' stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
        '<path d="M12 20.5 4.6 13.3C2.6 11.4 2 9.9 2 8.4 2 5.6 4.2 3.5 6.9 3.5c1.9 0 3.6 1 4.6 2.6h1C13.5 4.5 15.2 3.5 17.1 3.5 19.8 3.5 22 5.6 22 8.4c0 1.5-.6 3-2.6 4.9z"/>' +
        '</svg></button>';

      const brand = p.vendor ? '<p class="pc034__brand">' + this.esc(p.vendor) + '</p>' : '';
      const compareHtml = hasCompare ? '<s class="pc034__compare">' + this.money(compare) + '</s>' : '';

      let mainPrice;
      if (cfg.showPix && pixPercent > 0) {
        mainPrice =
          '<span class="pc034__pix"><span class="pc034__pix-value">' + this.money(pixPrice) + '</span>' +
          (cfg.pixLabel ? ' <span class="pc034__pix-label">' + this.esc(cfg.pixLabel) + '</span>' : '') +
          '</span>';
      } else {
        mainPrice = '<span class="pc034__price">' + this.money(price) + '</span>';
      }

      const installHtml = showInstallments
        ? '<p class="pc034__installment">' +
          this.esc(cfg.installmentsText)
            .replace('[preco]', this.money(price))
            .replace('[n]', String(parcelas))
            .replace('[valor]', this.money(Math.floor(price / parcelas))) +
          '</p>'
        : '';

      return (
        '<div class="pc034 pc034--portrait' + (soldOut ? ' pc034--soldout' : '') + '" role="listitem"' +
        ' data-product-id="' + p.id + '" data-product-handle="' + this.esc(p.handle) + '">' +
        '<div class="pc034__media-wrap">' + badge + wishBtn +
        '<a href="' + url + '" class="pc034__media" tabindex="-1" aria-hidden="true">' + imgHtml + '</a></div>' +
        '<div class="pc034__info">' + brand +
        '<a href="' + url + '" class="pc034__name">' + title + '</a>' +
        '<div class="pc034__prices"><p class="pc034__price-line">' + compareHtml + mainPrice + '</p>' + installHtml +
        '</div></div></div>'
      );
    }
  }

  if (!customElements.get('wishlist-page-034')) {
    customElements.define('wishlist-page-034', WishlistPage034);
  }

  } catch(e) { console.error(e); }
})();
})();
